








import { Component, Vue, Prop, Watch } from "vue-property-decorator";
import * as weatherService from "@/services/weather/index";
import AnalysesController from "./components/analyses-controller/AnalysesController.vue";
import * as analysesService from "@/services/analyses/index";
import * as cropsService from "@/services/crops/index";
import * as vegetationIndexesService from "@/services/vegetation-index/index";
import { Analysis } from "@/api/analyses/types";
import AgroInterativeLoading from "@/components/agroInterativeLoading/AgroInterativeLoading.vue";

@Component({
  name: "Analyses",
  components: {
    AnalysesController,
    AgroInterativeLoading
  },
})
export default class Analyses extends Vue {
  @Prop(String) private uuid?: string;
  @Prop({ type: String, default: "" }) private source?: string;

  private polling: number | null = null;

  private async mounted() {
    this.trackAnalysis(0);
  }

  private trackAnalysis(timeout: number = 1) {
    this.polling = setTimeout(async () => {
      try {
        await analysesService.getByUuid(this.uuid!);
        if (!this.analysis) {
          this.trackAnalysis(timeout === 0 ? 1 : Math.min(7000, timeout * 10));
        }
      } catch {}
    }, timeout);
  }

  private clearTracking() {
    if (this.polling != null) {
      clearTimeout(this.polling);
    }
    this.polling = null;
  }

  private get analysis(): Analysis {
    return this.$store.state.analyses.analysesContext;
  }

  private beforeDestroy() {
    this.clearTracking();
    Promise.all([
      analysesService.cleanup(),
      cropsService.cleanup(),
      vegetationIndexesService.cleanup(),
      weatherService.cleanup(),
    ]);
  }
}
